import styled, { css } from 'styled-components'

import { BarBase } from '@Components/Bar/Bar.styled'

interface BarProps {
  background: string
  color?: string
}

export const Bar = styled(BarBase)<BarProps>(({ background, color }) => css`
  background: ${background};
  color: ${color};

  p, h1, h2, h3, h4, h5,h6, span, strong, em, i {
    color: ${color};
  }
`)
